<template>
	<div class="outWrapper">
		<home-header></home-header>
		<div class="wrapper">
			<side-bar></side-bar>
			<countent></countent>
		</div>
	</div>
</template>
<script>
	import HomeHeader from './components/header/header';
	import sideBar from './components/sideBar/sideBar';
	import countent from './components/countent/countent';
	export default {
		name: 'Home',
		components: {
			HomeHeader,
			sideBar,
			countent
		},

		created() {
			this.init();
		},
		data() {
			return {
				
			}
		},

		methods: {
			init() {
				var userInfo = sessionStorage.getItem('drainage-userInfo');
				if (!userInfo) {
					  this.$message({
				        type: 'error',
				        message: '登录信息过期，请重新登录'
				      });
				      this.$router.push({
				        path: '/login'
				      });
				}

			}
		}
	}
</script>
<style lang='stylus' scoped>
	.outWrapper {
		overflow: hidden;
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		.wrapper {
			display: flex;
			width: 100%;
			position: absolute;
			top: 60px;
			left: 0;
			bottom: 0;
			right: 0;
			background-color: #F0F0F0;
			overflow: hidden;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/home/home.vue